module.exports = __webpack_public_path__ + "08_hair_brown.2d32492c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/08_hair_brown.png
// module id = po83
// module chunks = 0